import React from "react";
import { Button } from "../ui/button";

const Pagination = ({
    currentPage,
    totalPages,
    handlePreviousPage,
    handleNextPage,
    handlePageClick,
}) => (
    <div className="flex justify-center items-center mt-4 flex-wrap">
        <Button
            variant="outline"
            size="sm"
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
        >
            ← Précédent
        </Button>
        {[...Array(totalPages)].map((_, index) => (
            <Button
                key={index}
                variant={currentPage === index + 1 ? "default" : "outline"}
                size="sm"
                onClick={() => handlePageClick(index + 1)}
                className="mx-1"
            >
                {index + 1}
            </Button>
        ))}
        <Button
            variant="outline"
            size="sm"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
        >
            Suivant →
        </Button>
    </div>
);

export default Pagination;
